// Add fulfillment types based on the FulfilmentType enums file in mojo
export const FulfillmentTypes = {
  OnOrder: 0,
  Shipped: 1,
  Consignment: 2,
  DropShip: 3,
  None: 4,
  Employee: 5,
  Fulfillment: 6,
  Vintage: 7,
  DirectToConsumer: 8,
  MiraklEconcession: 9,
  MiraklDropship: 10
};
